// These are Requests as identified by 

import { 
  IEnhancementRecord,
} from './enhancements';

export interface ISerializedRequest {
  cache:  RequestCache,
  credentials: RequestCredentials,
  destination: RequestDestination,
  headers: { [key: string]: string}
  integrity: string
  isHistoryNavigation: boolean,
  isReloadNavigation: boolean,
  keepalive: boolean,
  method: string
  mode: RequestMode,
  redirect: RequestRedirect,
  referrer: string
  referrerPolicy: ReferrerPolicy,
  url: string
  body: string

  // Values added by StaffBar
  enhancement?: IEnhancementRecord
  initiatedTimestamp: number;
}

export interface ISerializedError {
  errorType: string,
  message: string,
}

export interface ISerializedResponse {
  ok: boolean
  headers: { [key: string]: string}
  redirected: boolean
  status: number
  statusText: string
  type: string
  url: string
  body: string
  completedTimestamp: number
}

export type RequestIdentifier  = string

export interface IRequestMetadata {
  id: RequestIdentifier,
  request: ISerializedRequest,
  error?: ISerializedError,
  response?: ISerializedResponse,
}


export interface IRequestMetadataNative {
  id: RequestIdentifier,
  request: Request,
  requestBody?: string,
  initiatedTimestamp: number;
  enhancement?: IEnhancementRecord,
  response?: Response,
  responseTest?: string,
  error?: Error,
  metadata?: { [key: string]: any},
}
